<template>
  <div>
    <h1>비밀번호 찾기</h1>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
